import app from "flarum/forum/app";
import Placeholder from "flarum/common/components/Placeholder";
export default class StoreItemUtils {
  static getInstance() {
    if (!StoreItemUtils.instance) {
      StoreItemUtils.instance = new StoreItemUtils();
    }
    return StoreItemUtils.instance;
  }
  getFilterProviderDict(dict) {
    dict['all'] = app.translator.trans("xypp-store.forum.provider.all");
  }
  createItemShowCase(item, purchase_history) {
    return m(Placeholder, {
      text: app.translator.trans('xypp-store.forum.provider.error.no-preview')
    });
  }
  getUseButtonName(item, confirm, alwaysShow) {
    if (item.unavailable()) {
      const tipKey = item.unavailable() || "";
      if (tipKey.split(".").length <= 2) return {
        text: app.translator.trans('xypp-store.forum.unavailable.' + tipKey),
        disable: true
      };
      return {
        text: app.translator.trans(tipKey),
        disable: true
      };
    } else if (!item.can_use() && !alwaysShow) {
      return {
        text: app.translator.trans("xypp-store.forum.history.unable_to_use"),
        disable: true
      };
    }
    if (confirm) {
      return {
        text: app.translator.trans("xypp-store.forum.history.confirm_use"),
        disable: false
      };
    }
    return {
      text: app.translator.trans("xypp-store.forum.history.use"),
      disable: false
    };
  }
  async getUseData(item) {
    return "";
  }
  async use(item) {
    const data = await this.getUseData(item);
    await this.useWithData(item, data);
  }
  async useWithData(item, data) {
    const result = await app.request({
      method: "POST",
      url: app.forum.attribute("apiUrl") + `/purchase-history/${item.id()}/use`,
      body: {
        data
      }
    });
    if (result.msg) {
      app.alerts.show({
        type: 'info'
      }, result.msg);
    }
  }
  getProviderName(provider) {
    return app.translator.trans("xypp-store.forum.provider.error.title");
  }
  async afterPurchase(item) {
    //To be override
  }
}
flarum.reg.add('xypp-store', 'forum/utils/StoreItemUtils', StoreItemUtils);